import React from 'react';
import { observer } from 'mobx-react';
import { UwTaskList } from '../../components/uw/UwTaskList';
import BaseContainer from '../BaseContainer';
import { AnonymousMainMenu } from './AnonymousMainMenu';
import { RouteComponentProps } from 'react-router';
import { TreuebonusBericht } from 'app/components/uw/TreuebonusBericht';
import { TreuebonusPlanung } from 'app/components/uw/TreuebonusPlanung';

// Sample UW tasks data
const SAMPLE_UW_TASKS = [
	{ agtId: '47119024', name: 'Müller & Partner OHG', amount: 12480.5 },
	{ agtId: '47118856', name: 'Allianz Generalvertretung Berger', amount: 4290.0 },
	{ agtId: '47120113', name: 'Schneider Versicherungen e.K.', amount: 23105.75 },
	{ agtId: '47119987', name: 'Hofmann Agentur', amount: 895.4 },
	{ agtId: '47118402', name: 'Weber & Söhne GbR', amount: 7820.0 },
	{ agtId: '47120441', name: 'Becker Vertretung', amount: 15640.2 },
	{ agtId: '47119215', name: 'Klein Agentur München-Süd', amount: 3340.9 },
	{ agtId: '47118770', name: 'Wagner & Co. KG', amount: 28950.0 },
	{ agtId: '47120098', name: 'Fischer Versicherungsbüro', amount: 6175.3 },
	{ agtId: '47119553', name: 'Schmidt Generalagentur', amount: 11240.85 },
];

export const UwTaskListDesign = observer((props: RouteComponentProps<{ level1?: string }>) => {
	return <UwTaskList tasks={SAMPLE_UW_TASKS} />;
});
export const TreuebonusBerichtDesign = observer((props: RouteComponentProps<{ level1?: string }>) => {
	return (
		<BaseContainer sideMenu={<AnonymousMainMenu {...props} />} navbar={<div>Treuebonusplanung</div>}>
			<TreuebonusPlanung />
		</BaseContainer>
	);
});
